import clsx from "clsx";
import React from "react";

import styles from "./PriceItem.module.scss";
import { Price } from "../../types/price";
import { PriceFromBackground, formatPrice } from "../utils";
import { PriceValue } from "../PriceBox/PriceBox";

export type PriceItemProps = {
  price: Price | undefined;
  variant: "small" | "normal" | "big";
  layout: "column" | "row" | "row-compact";
  priceType: "primary" | "secondary";
  showFareLabel: boolean;

  perGuestLabel?: string;
  lowestAvailableFareLabel?: string;
  chipBackgroundColor: PriceFromBackground;
  className?: string;
  fareClassName?: string;
  priceClassName?: string;
  perGuestClassName?: string;
};

export const PriceItem: React.FC<PriceItemProps> = ({
  price,
  priceType,
  showFareLabel,
  variant,
  layout,
  perGuestLabel,
  lowestAvailableFareLabel,
  chipBackgroundColor,
  className,
  fareClassName,
  priceClassName,
  perGuestClassName
}) => {
  if (!price) return null;

  return (
    <div
      className={clsx(
        styles.priceItem,
        {
          [styles.variantSmall]: variant == "small",
          [styles.variantNormal]: variant == "normal",
          [styles.variantBig]: variant == "big",
          [styles.variantRow]: layout == "row",
          [styles.variantRowCompact]: layout == "row-compact",
          [styles.variantColumn]: layout == "column"
        },
        className
      )}
    >
      {showFareLabel && (
        <div className={clsx(styles.fareLabel, fareClassName)}>
          {price.fareLabel}
        </div>
      )}
      <PriceValue
        price={price}
        className={clsx(styles.price, priceClassName)}
        chipBackgroundColor={chipBackgroundColor}
        priceType={priceType}
      />

      {(perGuestLabel || lowestAvailableFareLabel) && (
        <div className={clsx(styles.perGuest, perGuestClassName)}>
          {perGuestLabel && <div>{perGuestLabel}</div>}
          {lowestAvailableFareLabel && <div>{lowestAvailableFareLabel}</div>}
        </div>
      )}
    </div>
  );
};
